import React from 'react';
import PageWrapper from '../layout/PageWrapper';
import { PawPrint } from 'lucide-react';
import AnimalList from '../components/AnimalList';
import { LiaHorseHeadSolid } from "react-icons/lia";

/**
 * Harmonisation:
 * - Header unique via PageWrapper (icône + titre)
 * - Conteneur largeur uniforme (max-w-7xl)
 * - Overflow horizontal si nécessaire
 * - Supprime le H1 interne si présent
 */
export default function AnimauxPage() {
  return (
    <PageWrapper icon={LiaHorseHeadSolid} title="Animaux" maxWidth="max-w-full">
      {/* Masque un éventuel <h1> en premier niveau */}
      <style>{`.page-content > h1:first-of-type{display:none}`}</style>

      <div className="page-content mx-auto max-w-7xl">
        <div className="overflow-x-auto">
          <AnimalList />
        </div>
      </div>
    </PageWrapper>
  );
}
